import {
  Container,
  Stack,
  Typography,
  IconButton,
  Box,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Pagination,
  PaginationItem,
  CircularProgress,
  Tooltip,
  Snackbar,
  Alert,
  Avatar,
  Rating,
  DialogActions
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import Page from 'src/components/Page';
import { Link as RouterLink } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; // Adapter for Day.js
import Iconify from 'src/components/Iconify';
import { api } from 'src/Api';
import moment from 'moment';
import Empty_Truck from '../asset/open-door.png';

// import Empty_Truck from '../asset/open-door.png';
import { LoadingButton } from '@mui/lab';
import Searchbar from 'src/layouts/dashboard/Searchbar';

function Companies() {
  const [myLoadList, setMyLoadList] = useState([]);
  const [ratingReviewData, setRatingReviewData] = useState([]);
  const [loading, setloading] = useState(false);
  const [isStatusLoading, setIsStatusLoading] = useState(false);
  const [pagesCount, setpagesCount] = useState(1);
  const [page, setPage] = useState(1);

  const [loadingReview, setloadingReview] = useState(false);
  const [pagesCountReview, setpagesCountReview] = useState(1);
  const [pageReview, setPageReview] = useState(1);

  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [selectLoad, setSelectLoad] = useState('');
  const [selectedId, setSelectedId] = useState(null);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const [searchLoading, setsearchLoading] = useState(false);
  const [search, setsearch] = useState('');

  useEffect(() => {
    if (search.length == 0) {
      myLoadList.length = 0;
      handleGetCompanies(page);
    }
  }, [search]); 

  useEffect(() => {
    handleGetCompanies(page);
  }, [page]);

  // useEffect(() => {
  //   handleGetCompanies(1);
  // }, []);

  useEffect(() => {
    if (selectedId) {
      handleChangeStatusCompany(selectedId);
    }
  }, [selectedId]);

  useEffect(() => {
    if (selectLoad) {
      handleGetRatingReview(1);
    }
  }, [selectLoad]);

  // Detail Dialog Handlers
  const handleOpenDetailsModal = () => setOpenDetailsModal(true);
  const handleCloseDetailsModal = () => setOpenDetailsModal(false);

  function handleGetCompanies(page) {
    setMyLoadList([]);
    setloading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    search.length > 0 && queryParams.append('search', search);
    page && queryParams.append('page', page);

    fetch(`${api.get_company_list}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setMyLoadList(result.data);
          result?.count ? setpagesCount(Math.ceil(result?.count / 10)) : setpagesCount(1);
          setloading(false);
          setsearchLoading(false)
        } else {
          setloading(false);
          setSnackbarMessage(result.error);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
          setsearchLoading(false)
        }
      })
      .catch((error) => {
        console.log('error', error);
        setloading(false);
        setsearchLoading(false)
      });
  }

  function handleGetRatingReview(page) {
    setRatingReviewData([]);
    setloadingReview(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    page && queryParams.append('page', page);
    selectLoad && queryParams.append('user_id', selectLoad);

    fetch(`${api.get_reviews}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setRatingReviewData(result.data);
          result?.count
            ? setpagesCountReview(Math.ceil(result?.count / 10))
            : setpagesCountReview(1);
          setloadingReview(false);
          setSelectLoad('');
        } else {
          setloadingReview(false);
          setSelectLoad('');
        }
      })
      .catch((error) => {
        console.log('error', error);
        setloadingReview(false);
        setSelectLoad('');
      });
  }

  const handlePageChange = (event, value) => {
    myLoadList.length = 0;
    setPage(value);
    handleGetCompanies(value);
  };

  const handlePageChangeReview = (event, value) => {
    ratingReviewData.length = 0;
    setPageReview(value);
    handleGetRatingReview(value);
  };

  // close snackbarclose funtion
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  //delete contact function
  function handleChangeStatusCompany({ id, status }) {
    setIsStatusLoading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdatas = new FormData();
    id && formdatas.append('user_id', id);
    status && formdatas.append('status', status == 'blocked' ? 10 : 14);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdatas,
      redirect: 'follow'
    };

    fetch(api.action_block_unblock, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          handleGetCompanies(page);
          setIsStatusLoading(false);
          setSelectedId(null);
          setTimeout(() => {
            handleSnackbarClose();
          }, 1000);
        } else {
          setIsStatusLoading(false);
          setSnackbarMessage(result.errors);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
          setSelectedId(null);
        }
      })
      .catch((error) => {
        setIsStatusLoading(false);
        setSnackbarMessage('An error occurred.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setSelectedId(null);
      });
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Page title={`Companies | ${process.env.REACT_APP_PROJECTNAME}`}>
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0}>
            <Typography variant="h4" sx={{ color: '#010f58' }}>
              Companies
            </Typography>
          </Stack>

          <Box
            style={{
              flexDirection: 'column',
              display: 'flex',
              flex: 1,
              marginTop: 10
            }}
            className="top_column"
          >
            <Box
              style={{
                flexDirection: 'row',
                display: 'flex',
                flex: 1
              }}
              className="top_column"
            >
              <Searchbar
                width={'100%'}
                fullWidth
                setFunction={(val) => {
                  setsearch(val);
                }}
                className="width_full_property"
                placeholder={'Search Companies'}
                onEnter={() => {
                  setsearchLoading(true);
                  myLoadList.length = 0;
                  handleGetCompanies();
                }}
              />
              <LoadingButton
                style={{ width: '15%', marginLeft: '2.5%' }}
                variant="contained"
                className="width_full_status"
                loading={searchLoading}
                onClick={() => {
                  setsearchLoading(true);
                  setPage(1);
                  handleGetCompanies(1);
                }}
              >
                <Iconify icon="material-symbols:search" sx={{ width: 25, height: 25 }} />
              </LoadingButton>
            </Box>
          </Box>

          <TableContainer
            component={Paper}
            sx={{ boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.1)', mt: 2, mb: 2 }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>COMPANY</TableCell>
                  <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>EMAIL</TableCell>
                  <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>CONTACT NO</TableCell>
                  <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>ROLE</TableCell>
                  <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>RATING</TableCell>
                  <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>STATUS</TableCell>
                  <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>ACTION</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {myLoadList.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell sx={{ fontSize: '12px' }}>{row?.company || '-'}</TableCell>

                    <TableCell sx={{ fontSize: '12px' }}>{row?.email || '-'}</TableCell>

                    <TableCell sx={{ fontSize: '12px' }}>{row?.contact_no || 'N/A'}</TableCell>

                    <TableCell sx={{ fontSize: '12px' }}>{row?.role?.role_name || '-'}</TableCell>

                    <TableCell sx={{ fontSize: '12px' }}>{row?.rating || '0'}</TableCell>

                    <TableCell align="left" sx={{ fontSize: '12px' }}>
                      <Typography
                        style={{ fontSize: '12px' }}
                        className={
                          (row?.status?.toLowerCase() == 'unblocked' && 'status-green') ||
                          (row?.status?.toLowerCase() == 'blocked' && 'status-red')
                        }
                      >
                        {row?.status || 'N/A'}
                      </Typography>
                    </TableCell>

                    <TableCell sx={{ fontSize: '12px', width: 160 }}>
                      <Tooltip
                        title={row?.status?.toLowerCase() == 'unblocked' ? 'Block' : 'Unblock'}
                      >
                        <LoadingButton
                          size="small"
                          variant="contained"
                          onClick={() => {
                            setSelectedId({ id: row?.id, status: row?.status.toLowerCase() });
                          }}
                          loading={isStatusLoading && selectedId?.id == row.id}
                          style={{
                            width: 30,
                            height: 30,
                            minWidth: 30,
                            padding: 0,
                            lineHeight: 1,
                            marginRight: 5
                          }}
                        >
                          {!isStatusLoading || selectedId?.id !== row.id ? (
                            <Iconify
                              style={{ cursor: 'pointer', fontSize: 15, color: '#ffffff' }}
                              icon={
                                row?.status?.toLowerCase() == 'unblocked'
                                  ? 'ooui:block'
                                  : 'ooui:un-block'
                              }
                            />
                          ) : null}
                        </LoadingButton>
                      </Tooltip>

                      <Tooltip title="Private Network">
                        <LoadingButton
                          size="small"
                          variant="contained"
                          component={RouterLink}
                          to="/dashboard/companies/private_network"
                          state={{ company_id: row.id }}
                          style={{
                            width: 30,
                            height: 30,
                            minWidth: 30,
                            padding: 0,
                            lineHeight: 1,
                            marginRight: 5
                          }}
                        >
                          <Iconify
                            style={{ cursor: 'pointer', fontSize: 17, color: '#ffffff' }}
                            icon="ph:network-fill"
                          />
                        </LoadingButton>
                      </Tooltip>

                      <Tooltip title="Reviews">
                        <LoadingButton
                          size="small"
                          variant="contained"
                          onClick={() => {
                            handleOpenDetailsModal();
                            setSelectLoad(row?.id);
                          }}
                          style={{
                            width: 30,
                            height: 30,
                            minWidth: 30,
                            padding: 0,
                            lineHeight: 1,
                            marginRight: 5
                          }}
                        >
                          <Iconify
                            style={{ cursor: 'pointer', fontSize: 17, color: '#ffffff' }}
                            icon="material-symbols:reviews"
                          />
                        </LoadingButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>

              {/* loader */}
              {loading && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}

              {/* empty list */}
              {myLoadList.length == 0 && !loading && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        height="45vh"
                      >
                        <img
                          src={Empty_Truck}
                          alt="No Trucks"
                          style={{ width: '140px', marginBottom: '10px', marginRight: 40 }}
                        />
                        <Typography variant="h5" gutterBottom>
                          Companies not found
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>

          {/* Pagination */}
          {!loading && pagesCount > 1 && myLoadList.length !== 0 && (
            <Box
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                marginTop: 20,
                alignItems: 'center',
                marginBottom: 20
              }}
            >
              <Pagination
                color="primary"
                shape="rounded"
                page={page}
                size="small"
                count={pagesCount}
                onChange={handlePageChange}
                renderItem={(item) => <PaginationItem {...item} />}
              />
            </Box>
          )}
        </Container>

        {/* DETAILS dialog */}
        <Dialog maxWidth="md" open={openDetailsModal} onClose={handleCloseDetailsModal} fullWidth>
          <DialogTitle
            style={{
              height: 50,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              paddingLeft: 10,
              paddingRight: 10
            }}
          >
            Review & Rating
            <IconButton
              onClick={handleCloseDetailsModal}
              // sx={{ alignSelf: "end", float: 'right' }}
            >
              <Iconify icon="ic:round-clear" style={{ fontSize: 19 }} />
            </IconButton>
          </DialogTitle>
          <DialogContent style={{ paddingLeft: 20, paddingTop: 0 }}>
            {loadingReview ? (
              <Box
                sx={{
                  height: 30,
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 2
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <>
                {ratingReviewData.map((val) => {
                  return (
                    <Box sx={{ mt: 0 }}>
                      <Box>
                        <Grid
                          container
                          sx={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'flex-start'
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'flex-start',
                              alignItems: 'flex-start',
                              marginBottom: 2,
                              flexWrap: 'wrap'
                            }}
                          >
                            <Box
                              sx={{
                                width: 100,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginRight: 1
                              }}
                            >
                              <Avatar
                                style={{ width: 50, height: 50, marginBottom: 5 }}
                                alt={val?.user?.first_name + ' ' + val?.user?.last_name}
                                src={val?.user?.avatar}
                              />
                              <Typography
                                variant="overline"
                                sx={{
                                  fontSize: 11,
                                  textTransform: 'capitalize'
                                }}
                              >
                                {val?.user?.first_name + ' ' + val?.user?.last_name}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                alignItems: 'flex-start',
                                marginTop: 0.5
                              }}
                            >
                              <Rating size="small" name="simple-controlled" value={val?.rating} />
                              <Typography
                                sx={{
                                  fontSize: 11,
                                  textTransform: 'capitalize',
                                  flexWrap: 'wrap',
                                  marginTop: 1,
                                  marginLeft: 0.4
                                }}
                              >
                                {val?.review}
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                      </Box>
                    </Box>
                  );
                })}
              </>
            )}

            {/* empty list */}
            {ratingReviewData.length == 0 && !loadingReview && (
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                height="25vh"
              >
                <Typography variant="h5" gutterBottom style={{ color: '#010f58' }}>
                   No Reviews found
                </Typography>
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            {/* Pagination */}
            {!loadingReview && pagesCountReview > 1 && ratingReviewData.length !== 0 && (
              <Box
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                  marginTop: 20,
                  alignItems: 'center',
                  marginBottom: 20
                }}
              >
                <Pagination
                  color="primary"
                  shape="rounded"
                  page={pageReview}
                  size="small"
                  count={pagesCountReview}
                  onChange={handlePageChangeReview}
                  renderItem={(item) => <PaginationItem {...item} />}
                />
              </Box>
            )}
          </DialogActions>
        </Dialog>

        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Page>
    </LocalizationProvider>
  );
}
export default Companies;
